import { useSelector } from "react-redux";
import { DialogContent } from "@mui/material";
import { RootState } from "../../../redux/store";
import RegisterEvent from "./RegisterEvent";
import BookEvent from "./BookEvent";
import PublishEvent from "./PublishEvent";
import UploadGallery from "./UploadGallery";
import DeleteEvent from "./deleteEvent";
import DeleteDocument from "../Documents/deleteDocument";

const dialogsTypesWise: any = {  
  "registerevent": () => <RegisterEvent/>,
  "bookevent": () => <BookEvent/>,
  "eventPublish": () => <PublishEvent/>,
  "UploadGallery": () => <UploadGallery />,
  "eventDelete":() => <DeleteEvent/>,
  "documentDelete":()=><DeleteDocument/>
}

const dialogTypeFullScreen: any = {

}

const EventRegister: React.FC = () => {
    const { type, isFullScreen } = useSelector((state: RootState) => state.dialog);

    return (
        <>
            {
                (isFullScreen && dialogTypeFullScreen[type]?.()) ?
                    (
                        <DialogContent sx={{ height: "100%", margin: 0, padding: 0 }}  > {dialogTypeFullScreen[type]?.() ?? null} </DialogContent>
                    ) : (
                        <>
                            {dialogsTypesWise[type]?.() ?? null}
                        </>
                    )
            }
        </>
    )
}
export default EventRegister;



